import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcOfficialAccount from '@/types/table/wkcOfficialAccount';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcOfficialAccountData extends WkcOfficialAccount {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcOfficialAccountController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcOfficialAccountData>>(API_CONTEXT + '/app/wkcOfficialAccount/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcOfficialAccountData>(API_CONTEXT + '/app/wkcOfficialAccount/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcOfficialAccount/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcOfficialAccount/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcOfficialAccount/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcOfficialAccount/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcOfficialAccount/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcOfficialAccount/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcOfficialAccount/deleteBatch', params, httpOptions);
  }
  static startOnlyOfficialaccount(params: ANY_OBJECT, httpOptions?: RequestOption) {
    const processDefinitionKey = params.processDefinitionKey || 'officialaccount';
    return super.post(API_CONTEXT + `/app/wkcOfficialAccount/startOnly/${processDefinitionKey}`, params, httpOptions);
  }
  static startWithBusinessKeyOfficialaccount(params: ANY_OBJECT, httpOptions?: RequestOption) {
    const processDefinitionKey = params.processDefinitionKey || 'officialaccount';
    return super.post(API_CONTEXT + `/app/wkcOfficialAccount/startWithBusinessKey/${processDefinitionKey}`, params, httpOptions);
  }
  static startAndTakeUserTaskOfficialaccount(params: ANY_OBJECT, httpOptions?: RequestOption) {
    const processDefinitionKey = params.processDefinitionKey || 'officialaccount';
    return super.post(API_CONTEXT + `/app/wkcOfficialAccount/startAndTakeUserTask/${processDefinitionKey}`, params, httpOptions);
  }
  static startAndSaveDraftOfficialaccount(params: ANY_OBJECT, httpOptions?: RequestOption) {
    const processDefinitionKey = params.processDefinitionKey || 'officialaccount';
    return super.post(API_CONTEXT + `/app/wkcOfficialAccount/startAndSaveDraft/${processDefinitionKey}`, params, httpOptions);
  }
  static submitUserTaskOfficialaccount(params: ANY_OBJECT, httpOptions?: RequestOption) {
    const processDefinitionKey = params.processDefinitionKey || 'officialaccount';
    return super.post(API_CONTEXT + `/app/wkcOfficialAccount/submitUserTask/${processDefinitionKey}`, params, httpOptions);
  }
  static viewTaskBusinessDataOfficialaccount(params: ANY_OBJECT, httpOptions?: RequestOption) {
    const processDefinitionKey = params.processDefinitionKey || 'officialaccount';
    return super.get(API_CONTEXT + `/app/wkcOfficialAccount/viewTaskBusinessData/${processDefinitionKey}`, params, httpOptions);
  }
  static viewHistoricTaskBusinessDataOfficialaccount(params: ANY_OBJECT, httpOptions?: RequestOption) {
    const processDefinitionKey = params.processDefinitionKey || 'officialaccount';
    return super.get(API_CONTEXT + `/app/wkcOfficialAccount/viewHistoricTaskBusinessData/${processDefinitionKey}`, params, httpOptions);
  }
  static listWorkOrderOfficialaccount(params: ANY_OBJECT, httpOptions?: RequestOption) {
    const processDefinitionKey = params.processDefinitionKey || 'officialaccount';
    return super.post(API_CONTEXT + `/app/wkcOfficialAccount/listWorkOrder/${processDefinitionKey}`, params, httpOptions);
  }
   static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.post<ANY_OBJECT>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
      }
  static getCurrentApprovalStage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<ANY_OBJECT>(API_CONTEXT + '/app/wkcOfficialAccount/getCurrentApprovalStage', params, httpOptions);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

  /**
   * 公众号审批数据集（根据工单ID）
   */
  static getOfficialAccountDataset(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcOfficialAccount/getOfficialAccountDataset', params, httpOptions);
  }

  /**
   * 公众号审批-试用数据集（根据工单ID）
   */
  static getNewOfficialAccountDataset(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcOfficialAccount/getNewOfficialAccountDataset', params, httpOptions);
  }
}
